'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { getBranchConfig } from './utils';
export const BranchLegacy = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getBranchConfig();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const config = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...(config.enableJourneys && {
        enable_journeys: true
      }),
      ...(config.debug && {
        debug: true
      })
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initOptions = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Script id="branch-sdk" src={config.branchScriptUrl} strategy="afterInteractive" onLoad={() => window.branch?.init(config.branchKey, initOptions)} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};